// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/chats/chat_request_status.proto (package protos.entities.app.chats, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file entities/app/chats/chat_request_status.proto.
 */
export const file_entities_app_chats_chat_request_status: GenFile = /*@__PURE__*/
  fileDesc("CixlbnRpdGllcy9hcHAvY2hhdHMvY2hhdF9yZXF1ZXN0X3N0YXR1cy5wcm90bxIZcHJvdG9zLmVudGl0aWVzLmFwcC5jaGF0cyp3ChFDaGF0UmVxdWVzdFN0YXR1cxIfChtDSEFUX1JFUVVFU1RfU1RBVFVTX1VOS05PV04QABIfChtDSEFUX1JFUVVFU1RfU1RBVFVTX1BFTkRJTkcQARIgChxDSEFUX1JFUVVFU1RfU1RBVFVTX0FDQ0VQVEVEEAJiBnByb3RvMw");

/**
 * @generated from enum protos.entities.app.chats.ChatRequestStatus
 */
export enum ChatRequestStatus {
  /**
   * @generated from enum value: CHAT_REQUEST_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CHAT_REQUEST_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CHAT_REQUEST_STATUS_ACCEPTED = 2;
   */
  ACCEPTED = 2,
}

/**
 * Describes the enum protos.entities.app.chats.ChatRequestStatus.
 */
export const ChatRequestStatusSchema: GenEnum<ChatRequestStatus> = /*@__PURE__*/
  enumDesc(file_entities_app_chats_chat_request_status, 0);

